module.exports = __webpack_public_path__ + "media/images/flags/64/United-Kingdom-62b0ecc09470653e9e378937e5a850c3.png";